import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from 'react-router-dom';
import * as Routers from './RouterNew';
import RoutesUrl from './Routes';
import configureStore from '../store/configureStore';
import initialState from '../store/InitialState.config';
import history from '../utils/History';
import Loader from '../components/containers/Admin/Login.container'


const AppRouter = () => (
  <Provider store={configureStore({ initialState })}>
    <Router history={history}>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path={RoutesUrl.ADMINLOGIN} element={<Routers.LoginContainer />} />

         

          
          <Route path={RoutesUrl.FEEDBACK} element={<Routers.Feedback />} />


          {/* TeaGardenEnd */}
         
          <Route path={RoutesUrl.UPLOAD_DOCUMENT} element={<Routers.UPLOAD_DOCUMENT />} />
         
          <Route path={RoutesUrl.E_NACH_PAGE} element={<Routers.ENACHPAGE />} />
          <Route path={RoutesUrl.E_SIGN_NACH_PAGE} element={<Routers.ENACHPAGE />} />
          <Route path={RoutesUrl.E_SIGN_PAGE} element={<Routers.ESIGNPAGE />} />
        
        
          <Route path={RoutesUrl.Reference} element={<Routers.Reference />} />
        
          <Route path={RoutesUrl.E_NACH_PAGE_MOBILE} element={<Routers.EnachMobile />} />
          <Route path={RoutesUrl.E_SIGN_PAGE_MOBILE} element={<Routers.EsignMobile />} />
        
          <Route path={RoutesUrl.E_NACH_PAGE_CARD} element={<Routers.EnachCardPage />} />
          <Route path={RoutesUrl.E_SIGN_PAGE_CARD} element={<Routers.EsignCardPage />} />
       
          <Route path={RoutesUrl.KYC_FORM} element={<Routers.KYC_FORM />} />
          <Route path={RoutesUrl.KYC_FORM_SIGNZY} element={<Routers.KYC_FORM_SIGNZY />} />
          <Route path={RoutesUrl.KYC_REDIRECT_URL} element={<Routers.KYC_REDIRECT_URL />} />
          <Route path={RoutesUrl.KYC_MOBILE} element={<Routers.KYC_MOBILE />} />
         
          <Route path={RoutesUrl.DIGILOCKER_KYC} element={<Routers.DIGILOCKER_KYC />} />
          <Route path={RoutesUrl.KFS_PAGE} element={<Routers.KFS_PAGE />} />
          <Route path={RoutesUrl.FI_VERIFICATION} element={<Routers.FI_VERIFICATION />} />
          <Route path={RoutesUrl.ESIGN_REDIRECT_URL} element={<Routers.ESIGN_REDIRECT_URL />} />
          <Route path={RoutesUrl.DO_LETTER} element={<Routers.DO_LETTER />} />
          <Route path={RoutesUrl.VIDEO_KYC} element={<Routers.VIDEO_KYC />} />
          <Route path={RoutesUrl.VIDEO_KYC_REDIRECT} element={<Routers.VIDEO_KYC_REDIRECT />} />
          <Route path={RoutesUrl.LOAN_CALCULATOR_SITE} element={<Routers.LOAN_CALCULATOR_SITE />} />
          
          <Route path={RoutesUrl.ENACH_WITH_ZIPNACH} element={<Routers.ENACH_WITH_ZIPNACH />} />
        </Routes>
      </Suspense>
    </Router>
  </Provider>
)


export default AppRouter;
